import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { MyContext } from "../../Context/MyProvider";
import HomeCareBook from "./HomeCareBook";

export default function HomeCareHome() {
  const { ApiBaseUrl, setIsLoginShow } = useContext(MyContext);
  const { id: routeServiceId } = useParams();
  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [q, setQ] = useState("");
  const [bookServiceId, setBookServiceId] = useState(null);
  const navigate = useNavigate();

  const load = () => {
    axios.get(`${ApiBaseUrl}/hc/customer/categories`).then((r) => setCategories(r.data.categories || []));
    const params = new URLSearchParams();
    if (categoryId) params.set("category_id", categoryId);
    if (q) params.set("q", q);
    axios.get(`${ApiBaseUrl}/hc/customer/services?${params}`).then((r) => setServices(r.data.services || []));
  };

  useEffect(() => { load(); }, [categoryId]);

  useEffect(() => {
    if (!routeServiceId) return;
    const uid = secureLocalStorage.getItem("Userid");
    if (!uid) {
      setIsLoginShow(true);
      return;
    }
    setBookServiceId(routeServiceId);
  }, [routeServiceId, setIsLoginShow]);

  const openBook = (serviceId) => {
    const uid = secureLocalStorage.getItem("Userid");
    if (!uid) {
      setIsLoginShow(true);
      return;
    }
    setBookServiceId(serviceId);
  };

  const closeBook = () => {
    setBookServiceId(null);
    if (routeServiceId) navigate("/home-care");
  };

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
        <div>
          <h1 className="text-3xl font-bold text-rm-ink">Home Care</h1>
          <p className="text-gray-600">Book nurses, physios, caregivers and more at your doorstep.</p>
        </div>
        <button className="bg-rm-primary text-white px-4 py-2 rounded" onClick={() => navigate("/home-care/bookings")}>My Home Visits</button>
      </div>

      <div className="flex flex-wrap gap-3 mb-6">
        <select className="border rounded px-3 py-2" value={categoryId} onChange={(e) => setCategoryId(e.target.value)}>
          <option value="">All categories</option>
          {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
        <input className="border rounded px-3 py-2 flex-1 min-w-[200px]" placeholder="Search services" value={q} onChange={(e) => setQ(e.target.value)} />
        <button className="bg-rm-primary text-white px-4 py-2 rounded" onClick={load}>Search</button>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {services.map((s) => (
          <div key={s.id} className="border rounded-xl p-4 shadow-sm bg-white">
            <p className="text-xs uppercase text-rm-primary">{s.category_name}</p>
            <h3 className="text-xl font-semibold mt-1">{s.name}</h3>
            <p className="text-sm text-gray-600 mt-2 line-clamp-3">{s.description}</p>
            <div className="flex justify-between items-center mt-4">
              <div>
                <p className="font-bold text-lg">₹{s.base_price}</p>
                <p className="text-xs text-gray-500">{s.duration_minutes} mins</p>
              </div>
              <button
                className="bg-rm-primary text-white px-3 py-2 rounded"
                onClick={() => openBook(s.id)}
              >Book</button>
            </div>
          </div>
        ))}
      </div>
      {!services.length && <p className="text-center text-gray-500 py-10">No services found.</p>}
      {bookServiceId && (
        <HomeCareBook serviceId={bookServiceId} onClose={closeBook} />
      )}
    </div>
  );
}
